import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { styles } from './styles';
import analytics from '../../../utils/analytics';

const ANDES_REFINANCE_URL = 'https://andesap.cl/ingreso';

export default function MortgageRefinanceAndesContent() {
  const goToAndes = () => {
    analytics.track('Click Boton', {
      text: 'Ir a Andes - refinanciamiento hipotecario',
      initiator: 'usuario',
    });
    window.location.assign(ANDES_REFINANCE_URL);
  };

  return (
    <Box sx={styles.boxContainer}>
      <Typography variant="body1" component="div">
        Para solicitar la opción de refinanciamiento de tu crédito hipotecario, serás
        {' '}
        dirigido al sitio de
        {' '}
        <Typography component="span" fontWeight="bold" color="secondary">
          Andes
        </Typography>
        , donde podrás completar tu solicitud.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        size="large"
        sx={{ marginTop: 1, width: '100%' }}
        onClick={goToAndes}
      >
        Ir a Andes
      </Button>
    </Box>
  );
}
